export default "__VITE_ASSET__caaf74a9__"